export const styles = {
	sideBar: {
		display: { xs: 'none', sm: 'block' },
		minWidth: '4px',
		background: 'linear-gradient(180deg, #C8003C 51%, #FF437B 100%)',
	},
	header: { marginY: '2rem' },
}
